import axios from 'axios';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api/bankdata-mappings';

/**
 * Get all bank data field mappings
 * @returns {Promise<Array>} Array of bank data field mappings
 */
export const getBankDataMappings = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching bank data mappings:', error);
    throw error;
  }
};

/**
 * Save bank data field mappings
 * @param {Array} mappings - Array of mapping objects to save
 * @returns {Promise<Object>} Response with success status
 */
export const saveBankDataMappings = async (mappings) => {
  try {
    const response = await axios.post(API_URL, { mappings });
    return response.data;
  } catch (error) {
    console.error('Error saving bank data mappings:', error);
    throw error;
  }
};

/**
 * Get child objects (related lists) for a parent Salesforce object
 * @param {string} parentObject - Parent object name (Opportunity, Account, Contact)
 * @returns {Promise<Array>} Array of child object relationships
 */
export const getChildObjects = async (parentObject) => {
  try {
    const response = await axios.get(`${API_URL}/child-objects/${parentObject}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching child objects for ${parentObject}:`, error);
    throw error;
  }
};

/**
 * Get fields for a child object
 * @param {string} childObject - Child object API name
 * @returns {Promise<Array>} Array of field definitions
 */
export const getChildObjectFields = async (childObject) => {
  try {
    const response = await axios.get(`${API_URL}/child-fields/${childObject}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching fields for ${childObject}:`, error);
    throw error;
  }
};

/**
 * Get bank statement data for an opportunity
 * @param {string} opportunityId - Salesforce Opportunity ID
 * @returns {Promise<Object>} Object with bank statement field values
 */
export const getBankStatementData = async (opportunityId) => {
  try {
    const response = await axios.get(`${API_URL}/opportunity/${opportunityId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching bank statement data for opportunity ${opportunityId}:`, error);
    throw error;
  }
};

